import React from 'react';

// Phase 92D · Task 0 — Fitness STANDARD visualization.
//
// Renders the athlete's result against the SAME canonical Fitness Standards used
// by the Fitness Assessment module (Needs Improvement | Standard | Good |
// Excellent), reusing the server-computed classification (age/sex AT test date)
// and the tier band thresholds. This is NOT a Phase 91A Development Target.
//
// Directionality: the classification already accounts for lower-is-better vs
// higher-is-better, so the marker is placed in the tier segment that the
// athlete's classification falls into. Each segment shows its numeric range.

// Standard color_key → semantic classes (mirrors PerformanceBadge / Fitness UI).
const SEG = {
  green: { fill: 'bg-emerald-500', soft: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  blue: { fill: 'bg-sky-500', soft: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-200' },
  amber: { fill: 'bg-amber-500', soft: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  red: { fill: 'bg-rose-500', soft: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  gray: { fill: 'bg-slate-400', soft: 'bg-slate-50', text: 'text-slate-600', border: 'border-slate-200' },
};

const FitnessStandardBand = ({ bands, standard, testId = 'fitness-standard-band' }) => {
  if (!bands || !Array.isArray(bands.tiers) || bands.tiers.length === 0) return null;
  // Stored order is Excellent → Below (best → worst). Present worst → best.
  const segments = [...bands.tiers].reverse();
  const activeKey = standard?.performance_category || null;
  const activeIdx = segments.findIndex((t) => t.ui_key === activeKey);

  return (
    <div className="mt-2" data-testid={testId}>
      <div className="flex overflow-hidden rounded-md border border-slate-200">
        {segments.map((t, i) => {
          const c = SEG[t.color_key] || SEG.gray;
          const active = i === activeIdx;
          return (
            <div
              key={t.ui_key}
              className={`relative flex-1 px-2 py-1.5 text-center ${active ? c.soft : 'bg-white'} ${i > 0 ? 'border-l border-slate-200' : ''}`}
              data-testid={`${testId}-seg-${t.ui_key}${active ? '-active' : ''}`}
            >
              <div className={`h-1.5 w-full rounded-full ${c.fill} ${active ? 'opacity-100' : 'opacity-35'}`} />
              <div className={`mt-1 text-[10px] font-semibold leading-tight ${active ? c.text : 'text-slate-400'}`}>{t.ui_label}</div>
              <div className={`text-[9px] leading-tight ${active ? 'text-slate-500' : 'text-slate-300'}`}>{t.threshold_summary}</div>
              {active && <div className={`absolute inset-x-1 -top-px h-0.5 rounded-full ${c.fill}`} />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FitnessStandardBand;
